import { type MutationHookOptions, useMutation } from "@apollo/client";
import { StartStreamPullMutation } from "../graphql/mutations";
import type {
  StartStreamPullMutationType,
  StartStreamPullMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useStartStreamPullMutation = (
  options?: MutationHookOptions<
    StartStreamPullMutationType,
    StartStreamPullMutationVariablesType
  >
) => {
  return useMutation<
    StartStreamPullMutationType,
    StartStreamPullMutationVariablesType
  >(StartStreamPullMutation, options);
};
